import style from "../../style/test_result/guide/learningStrategy.module.scss";
import {RecommendationLeftJobDetail} from "./RecommendationLeftJobDetail";
import {BrainType} from "../../../types/testResult";
import {Trans, useTranslation} from "react-i18next";
import React from "react";
import {useLanguage} from "../../../hooks/hooks";

/* eslint-disable max-len */
export function RecommendationLeftJob() {
    const {t} = useTranslation("guideRecommendationJob");
    const {isKorean} = useLanguage();

    return(
        <>
            <div className={style.pageBody}>
                <article className={style.summary}>
                    <div className={style.titleWrapper}>
                        {isKorean? (
                            <h2 className={style.title}>
                                <span className={style.bold}>{t('summary.left.title')}</span>
                                <span className={`${style.light} ${style.small}`}>{t('summary.left.subTitle')}</span>
                                <span>{t('summary.left.job')}</span>
                            </h2>

                        ) : (
                            <h2 className={`${style.title} ${style.notKO}`}>
                                <span className={style.normalText}>{t('summary.left.job')}</span>
                                <span className={style.bold}>{t('summary.left.title')}</span>
                                <span className={`${style.light} ${style.small}`}>{t('summary.left.subTitle')}</span>
                            </h2>
                        )}

                        <div className={style.descriptionWrapper}>
                            <Trans t={t} i18nKey='summary.left.description'
                                   values={{blank: '\u00A0'}}
                                   components={{
                                       br: <br/>,
                                       bold: <p className={`${style.description} ${style.bold}`}/>,
                                       description: <p className={style.description}/>,
                                   }}/>
                        </div>
                    </div>
                    <hr className={style.underline}/>
                </article>

                <RecommendationLeftJobDetail brainType={BrainType.SUCCESSIVE} />
            </div>
        </>
    )
}